// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.opinion-options-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.summary-section {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;
  border: 1px solid #e9ecef;
}

.summary-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #212529;
  margin-bottom: 1rem;
}

.summary-content {
  font-size: 1rem;
  line-height: 1.6;
  color: #495057;
}

.options-section {
  margin-top: 2rem;
}

.options-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #212529;
  margin-bottom: 0.5rem;
}

.options-description {
  font-size: 1rem;
  color: #6c757d;
  margin-bottom: 1.5rem;
}

.opinion-options-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-top: 1.5rem;
}

.opinion-option-card {
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  padding: 1.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
}

.opinion-option-card:hover {
  border-color: #007bff;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.15);
  transform: translateY(-2px);
}

.opinion-option-card:active {
  transform: translateY(0);
}

.option-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.option-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #212529;
  margin: 0;
  flex: 1 1;
}

.option-number {
  background: #007bff;
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
  margin-left: 1rem;
}

.option-description {
  font-size: 0.95rem;
  line-height: 1.6;
  color: #6c757d;
  margin-bottom: 1.5rem;
  flex: 1 1;
}

.option-select-btn {
  background: #007bff;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s ease;
  margin-top: auto;
}

.option-select-btn:hover {
  background: #0056b3;
}

.option-select-btn:disabled {
  background: #6c757d;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .opinion-options-container {
    padding: 1rem;
  }

  .opinion-options-grid {
    grid-template-columns: 1fr;
  }
}

`, "",{"version":3,"sources":["webpack://./src/unAuth/components/OpinionOptions.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".opinion-options-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.summary-section {\n  background: #f8f9fa;\n  border-radius: 12px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n  border: 1px solid #e9ecef;\n}\n\n.summary-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #212529;\n  margin-bottom: 1rem;\n}\n\n.summary-content {\n  font-size: 1rem;\n  line-height: 1.6;\n  color: #495057;\n}\n\n.options-section {\n  margin-top: 2rem;\n}\n\n.options-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #212529;\n  margin-bottom: 0.5rem;\n}\n\n.options-description {\n  font-size: 1rem;\n  color: #6c757d;\n  margin-bottom: 1.5rem;\n}\n\n.opinion-options-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1.5rem;\n  margin-top: 1.5rem;\n}\n\n.opinion-option-card {\n  background: white;\n  border: 2px solid #e9ecef;\n  border-radius: 12px;\n  padding: 1.5rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  flex-direction: column;\n}\n\n.opinion-option-card:hover {\n  border-color: #007bff;\n  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.15);\n  transform: translateY(-2px);\n}\n\n.opinion-option-card:active {\n  transform: translateY(0);\n}\n\n.option-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n}\n\n.option-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #212529;\n  margin: 0;\n  flex: 1;\n}\n\n.option-number {\n  background: #007bff;\n  color: white;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  margin-left: 1rem;\n}\n\n.option-description {\n  font-size: 0.95rem;\n  line-height: 1.6;\n  color: #6c757d;\n  margin-bottom: 1.5rem;\n  flex: 1;\n}\n\n.option-select-btn {\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.3s ease;\n  margin-top: auto;\n}\n\n.option-select-btn:hover {\n  background: #0056b3;\n}\n\n.option-select-btn:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n  .opinion-options-container {\n    padding: 1rem;\n  }\n\n  .opinion-options-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
